import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

const SectionCard = ({ title, children, sx = {} }) => {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 4,
                p: { xs: 3, md: 4 },
                backgroundColor: '#fff7fb',
                border: '1px solid rgba(0, 71, 110, 0.10)',
                boxShadow: '0 10px 28px rgba(0, 71, 110, 0.07)',
                width: '100%',
                ...sx
            }}
        >
            {title && (
                <Box sx={{ mb: 2 }}>
                    <Typography
                        className="heading-font"
                        variant="h4"
                        sx={{
                            color: '#00476e',
                            fontWeight: 700,
                            mb: 1
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
            )}
            {children}
        </Paper>
    );
};

export default SectionCard;